<div class="recoil-graph">
  <svg [attr.height]="height || '100pt'" viewBox="0 0 200 100" xmlns="http://www.w3.org/2000/svg" *ngIf="svgPath" style="width: auto!important; color: #FFF;">
    <g transform="rotate(-90 100 100)">
      <circle r="100" cx="100" cy="100" fill="#fff" fill-opacity="0.2"></circle>
      <path [attr.d]="svgPath" fill="currentColor"></path>
    </g>
  </svg>
</div>
